export enum ReviewsSlug {
    SentRequests = 'sent-requests',
    CompanyRatings = 'company-ratings',
    ReceivedRequests = 'received-requests'
}
